import { io } from 'socket.io-client';

let socket;

export const getSocket = () => socket;

export const createSocketInstance = (token) => {
  if (token && !socket) {
    socket = io(
      import.meta.env.VITE_SOCKET_SERVER_URL || 
      import.meta.env.VITE_API_URL || 
      'https://agora-web-uvht.onrender.com',
      {
        auth: { token },
      }
    );
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
